import { DOMAINURL } from "../../services/config";

const EmailTemplate = ({ subject, headline, content }) => {
  return {
    subject,
    content: `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
          <style>
            body {
              font-family: 'Arial', sans-serif;
              background-color: #f8f9fa;
              margin: 0;
              padding: 0;
            }
            .container {
              max-width: 600px;
              margin: 0 auto;
              background: #ffffff;
              padding: 20px;
              box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
              border-radius: 8px;
            }
            .logo {
              text-align: center;
              margin-bottom: 30px;
            }
            .logo img {
              max-width: 180px;
              height: auto;
            }
            h1 {
              color: #28a745; /* Green title color */
              font-size: 28px;
              margin-bottom: 24px;
              text-align: center;
              font-weight: 600;
            }
            p {
              line-height: 1.6;
              margin-bottom: 16px;
              font-size: 16px;
              color: #333;
            }
            a.button {
              display: inline-block;
              padding: 12px 24px;
              background-color: #2980ba;
              color: #ffffff;
              text-decoration: none;
              border-radius: 4px;
              margin-top: 24px;
              text-align: center;
              font-size: 16px;
              font-weight: 500;
            }
            .footer {
              margin-top: 40px;
              font-size: 12px;
              color: #888888;
              text-align: center;
              border-top: 1px solid #eee;
              padding-top: 20px;
            }
            .footer a {
              color: #2980ba;
              text-decoration: none;
            }
            .footer a:hover {
              text-decoration: underline;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="logo">
              <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams Logo" />
            </div>
            ${headline ? `<h1>${headline}</h1>` : ""}
            <div>${content}</div>
          </div>
        </body>
      </html>
    `,
  };
};

export default EmailTemplate;

// <div class="footer">
//   <p>For assistance, feel free to <a href="mailto:support@proteams.io">contact support</a>.</p>
//   <p>&copy; ${new Date().getFullYear()} ProTeams.io. All rights reserved.</p>
// </div>
